import { EVENTBRITE_CATEGORY_MAPPING } from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { Link } from 'react-router-dom';
import {
    ReadMore,
    ReadMoreContent,
    ReadMoreToggle,
} from '../../../../components/ReadMore';
import { Tile, TileGroup } from '../../../../components/Tiles';
import { CATEGORY_LONG_NAME_ICON_MAP } from '../../../../constants';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { useEnvContext, useSearchContext } from '../../context';
import { useLocation } from '../../hooks/queries/location';
import { useAllTagsSortedByLocation } from '../../hooks/queries/tags';
import { generateBrowseUrl } from '../../utils';

export const CategoryBrowsePopularCategories: React.FunctionComponent = () => {
    const env = useEnvContext();
    const isBotRequest = env.isBotRequest;
    const popularCategoryKeys = useAllTagsSortedByLocation(
        EVENTBRITE_CATEGORY_MAPPING,
        'Category',
    );

    //Data for generating link
    const { query } = useSearchContext();
    const { data: location } = useLocation();

    if (!location) {
        return null;
    }

    return (
        <CategoryBrowseBucket
            title={gettext('Explore other popular categories')}
        >
            <ReadMore
                initialIsExpanded={isBotRequest}
                ariaLabel={gettext('Popular categories').toString()}
            >
                <ReadMoreContent
                    previewContentType="pixel"
                    previewPixelCount={{
                        mobile: '334px',
                        tablet: '200px',
                        desktop: '200px',
                    }}
                >
                    <TileGroup tiles={popularCategoryKeys}>
                        {(popularCategory = '') => (
                            <Link
                                key={popularCategory}
                                to={generateBrowseUrl(
                                    {
                                        ...query,
                                        tags: [popularCategory],
                                    },
                                    location,
                                )}
                                onClick={() => {
                                    trackAnalyticsEvent({
                                        category: 'category-page',
                                        action: 'CategoryCardClicked',
                                        label: EVENTBRITE_CATEGORY_MAPPING[
                                            popularCategory
                                        ],
                                    });
                                    typeof window !== undefined
                                        ? window.scrollTo(0, 0)
                                        : null;
                                }}
                            >
                                <Tile
                                    name={
                                        EVENTBRITE_CATEGORY_MAPPING[
                                            popularCategory
                                        ]
                                    }
                                    icon={
                                        CATEGORY_LONG_NAME_ICON_MAP[
                                            popularCategory
                                        ]
                                    }
                                />
                            </Link>
                        )}
                    </TileGroup>
                </ReadMoreContent>
                <ReadMoreToggle
                    labels={{
                        show: gettext('View more'),
                        hide: gettext('View less'),
                    }}
                />
            </ReadMore>
        </CategoryBrowseBucket>
    );
};
